import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    border: 1px solid var(--light-gray);
    border-radius: 10px;
    padding: 15px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
`;

export const Separator = styled.div`
background: var(--light-gray);
height: 1px;
width: 100%;
margin: 0 0 1rem;
`
export const AssociateContainer = styled.div`
display: flex;
flex-direction: row;
align-items: center;
margin: 0;
`

export const ProfilePictureWrapper = styled.div`
  position: relative;
  display: inline-block;
  margin-right: 20px;
  flex-shrink: 0;
`;

export const StarBadge = styled.div<{ isPremium?: boolean }>`
  position: absolute;
  bottom: 5px;
  right: 5px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: ${(props) => (props.isPremium ? "#F5C518" : "#A0A0A0")};
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid white;
  
  svg {
    fill: white;
    display: block;
    margin-bottom: 2px;
  }
`;

export const FixitLogo = styled.img`
width: 100px;
height: 100px;
border-radius: 50%;
background-color: var(--dark-gray);
object-fit: cover;
`

export const DataContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    h3 {
      display: inline;
      color: var(--dark-gray);
      margin: 0;
      font-size: 1.1rem;
    }
    
    .profession-text {
      color: var(--gray);
      font-size: 0.9rem;
      font-weight: 600;
      margin: 2px 0;
    }

  }

  .distance-info {
    display: flex;
    align-items: center;
    color: var(--gray);
    font-size: 0.9rem;
    margin: 5px 0;
    flex-wrap: wrap;
    gap: 12px;
  }
  }

  .distance-info {
    display: flex;
    align-items: center;
    color: var(--gray);
    font-size: 0.95rem;
    margin: 5px 0;
    flex-wrap: wrap;
    gap: 6px;
  }

  .address-text {
    color: var(--gray);
    font-size: 0.85rem;
    margin: 5px 0 15px 0;
    line-height: 1.3;
  }
`;

export const ActionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  gap: 15px;
  width: 100%;

  a {
    text-decoration: none;
    flex: 1;
    display: flex;
  }

  button {
    width: 100% !important;
  }

  @media (max-width: 600px) {
    flex-direction: row;
    
    a {
      width: 100%;
    }
  }
`;